export default {
  '2.0': [
    '编辑器支持 ctrl + s 保存，ctrl + d 退出',
    '新增更新弹窗提示',
    '新增项目版本管理'
  ],
  '2.1': [
    '搜索框添加重置',
    '发布操作时：项目支持下载图片到本地'
  ],
  '2.2': [
    '优化某种情况下，编辑节点时无法选中的问题',
    '去除自定义节点的外层包裹，例如 cell-group 和 cell 可以完美搭配使用！'
  ],
  '2.3': [
    '优化了事件管理',
    '统一了代码编辑器'
  ],
  '2.4': [
    '支持自定义节点 SPA 写法'
  ],
  '2.5': [
    '支持跨项目复制粘贴页面'
  ],
  '2.6': [
    '支持跨项目复制粘贴页面',
    '支持跨项目复制粘贴节点',
    '画布宽度自定义且自适应'
  ],
  '2.7': [
    '支持 fx 表达式',
    '新增内置变量'
  ]
}
